import { createSelector } from 'reselect';
import { getArmyBooksSelector } from '@Selectors/publication/book/selector/get-army-books.selector';
import { ArmyBookView } from '@Selectors/publication/book/view/army-book.view';

export const armyBooksPresenter = createSelector(
  [getArmyBooksSelector],
  (books): ArmyBookView[] => {
    return books.map((item) => {
      return {
        id: item.id,
        name: item.name,
        version: item.version,
      } satisfies ArmyBookView as ArmyBookView;
    });
  },
);
